import { render, staticRenderFns } from "./scheduling.vue?vue&type=template&id=dedf44e4&scoped=true"
import script from "./scheduling.vue?vue&type=script&lang=js"
export * from "./scheduling.vue?vue&type=script&lang=js"
import style0 from "./scheduling.vue?vue&type=style&index=0&id=dedf44e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedf44e4",
  null
  
)

export default component.exports